export default "__VITE_ASSET__ChXweI$Y__"